<template>
  <footer class="footer">
    <div class="container">
      <!-- Newsletter订阅区域 -->
      <div class="newsletter-section">
        <div class="newsletter-content">
          <div class="newsletter-text">
            <h3>Subscribe to Our Newsletter</h3>
            <p>Stay updated with our latest products, technology updates, and industry insights.</p>
          </div>
          <div class="newsletter-form">
            <form @submit.prevent="subscribeNewsletter" class="subscribe-form">
              <div class="form-group">
                <input 
                  type="email" 
                  v-model="email" 
                  placeholder="Enter your email address"
                  class="email-input"
                  required
                />
                <button type="submit" class="subscribe-btn" :disabled="isSubmitting">
                  <span v-if="!isSubmitting">Subscribe</span>
                  <span v-else class="loading-spinner"></span>
                </button>
              </div>
              <div class="form-options">
                <label class="checkbox-item">
                  <input type="checkbox" v-model="agreeTerms" required>
                  <span>I agree to receive marketing emails</span>
                </label>
              </div>
            </form>
            <div v-if="subscribeMessage" :class="['subscribe-message', subscribeStatus]">
              {{ subscribeMessage }}
            </div>
          </div>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="footer-content">
        <div class="footer-section">
          <h4>{{ companyName }}</h4>
          <p>Providing professional assistive solutions for people with disabilities, enabling independent living and a better quality of life.</p>
          <div class="social-links">
            <a href="#" class="social-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="#" class="social-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>
        
        <div class="footer-section">
          <h4>Products</h4>
          <ul class="footer-links">
            <li><router-link to="/wheelchairs">Power Chairs</router-link></li>
            <li><router-link to="/products">Seating & Positioning</router-link></li>
            <li><a href="#">Walking Aids</a></li>
            <li><a href="#">Prosthetics</a></li>
            <li><a href="#">Bathroom Safety</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>Support</h4>
          <ul class="footer-links">
            <li><a href="#">Product Consultation</a></li>
            <li><a href="#">Technical Support</a></li>
            <li><a href="#">Service & Repair</a></li>
            <li><a href="#">Training</a></li>
            <li><a href="#">FAQs</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h4>Contact Us</h4>
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-icon">📞</span>
              <span>{{ contact.phone }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📧</span>
              <span>{{ contact.email }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📍</span>
              <span>{{ contact.address }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p>&copy; 2024 {{ companyName }}. All rights reserved.</p>
          <div class="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookie Policy</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    companyName: {
      type: String,
      required: true
    },
    contact: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      email: '',
      agreeTerms: false,
      isSubmitting: false,
      subscribeMessage: '',
      subscribeStatus: ''
    }
  },
  methods: {
    async subscribeNewsletter() {
      if (!this.email || !this.agreeTerms) {
        this.showMessage('Please enter your email address and agree to the terms', 'error');
        return;
      }

      this.isSubmitting = true;
      
      try {
        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Here you can add actual API call
        // const response = await fetch('/api/newsletter/subscribe', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ email: this.email })
        // });
        
        this.showMessage('Subscription successful! Thank you for your interest. We will send you the latest updates regularly.', 'success');
        this.email = '';
        this.agreeTerms = false;
      } catch (error) {
        this.showMessage('Subscription failed, please try again later.', 'error');
      } finally {
        this.isSubmitting = false;
      }
    },
    
    showMessage(message, status) {
      this.subscribeMessage = message;
      this.subscribeStatus = status;
      
      setTimeout(() => {
        this.subscribeMessage = '';
        this.subscribeStatus = '';
      }, 5000);
    }
  }
}
</script>

<style scoped>
.footer {
  background: #1a1a1a;
  color: white;
  padding-top: 3rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Newsletter区域 */
.newsletter-section {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a7bc8 100%);
  border-radius: 16px;
  padding: 3rem;
  margin-bottom: 3rem;
  text-align: center;
}

.newsletter-content {
  max-width: 600px;
  margin: 0 auto;
}

.newsletter-text h3 {
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 300;
}

.newsletter-text p {
  font-size: 1.1rem;
  opacity: 0.9;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.newsletter-form {
  max-width: 400px;
  margin: 0 auto;
}

.subscribe-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  gap: 0.5rem;
}

.email-input {
  flex: 1;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
}

.email-input:focus {
  box-shadow: 0 0 0 3px rgba(255,255,255,0.2);
}

.subscribe-btn {
  background: #2c5aa0;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
}

.subscribe-btn:hover:not(:disabled) {
  background: #1e3a5f;
  transform: translateY(-2px);
}

.subscribe-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.form-options {
  text-align: left;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  opacity: 0.9;
  cursor: pointer;
}

.checkbox-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2c5aa0;
}

.subscribe-message {
  margin-top: 1rem;
  padding: 0.8rem;
  border-radius: 8px;
  font-size: 0.9rem;
}

.subscribe-message.success {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.subscribe-message.error {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

/* 主要内容区域 */
.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  margin-bottom: 3rem;
}

.footer-section h4 {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: #2c5aa0;
}

.footer-section p {
  line-height: 1.6;
  opacity: 0.8;
  margin-bottom: 1.5rem;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255,255,255,0.1);
  border-radius: 50%;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #2c5aa0;
  transform: translateY(-2px);
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.8rem;
}

.footer-links a {
  color: white;
  text-decoration: none;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  opacity: 1;
  color: #2c5aa0;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  opacity: 0.8;
}

.contact-icon {
  font-size: 1.2rem;
}

/* 底部版权 */
.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.1);
  padding: 2rem 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-bottom-links {
  display: flex;
  gap: 2rem;
}

.footer-bottom-links a {
  color: white;
  text-decoration: none;
  opacity: 0.8;
  font-size: 0.9rem;
  transition: opacity 0.3s ease;
}

.footer-bottom-links a:hover {
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .newsletter-section {
    padding: 2rem 1rem;
  }
  
  .newsletter-text h3 {
    font-size: 1.5rem;
  }
  
  .form-group {
    flex-direction: column;
  }
  
  .subscribe-btn {
    width: 100%;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-bottom-links {
    justify-content: center;
  }
}
</style> 